import { useCallback, useEffect, useState } from "react";
import { Input, Spin, Table } from "antd";
import type { TableColumnsType } from "antd";
import { AdminListShell } from "../components/admin/AdminListShell";
import { fetchAdminAlertDispatchesPage } from "../api/client";
import type { AdminAlertDispatchRow } from "../api/types";
import { fmtDateTime } from "../lib/formatAdmin";

export function AlertDispatchesPage() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [userId, setUserId] = useState("");
  const [items, setItems] = useState<AdminAlertDispatchRow[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<"forbidden" | "error" | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setErr(null);
    const r = await fetchAdminAlertDispatchesPage({
      page,
      page_size: pageSize,
      user_id: userId || undefined,
    });
    if (r === "forbidden") setErr("forbidden");
    else if (r === "error") setErr("error");
    else {
      setItems(r.items);
      setTotal(r.total);
    }
    setLoading(false);
  }, [page, pageSize, userId]);

  useEffect(() => {
    void load();
  }, [load]);

  useEffect(() => {
    setPage(1);
  }, [userId]);

  const columns: TableColumnsType<AdminAlertDispatchRow> = [
    { title: "用户邮箱", dataIndex: "user_email", key: "em", width: 200, ellipsis: true },
    {
      title: "监管标题",
      dataIndex: "raw_title",
      key: "ti",
      ellipsis: true,
    },
    {
      title: "链接",
      dataIndex: "raw_link",
      key: "lk",
      width: 100,
      render: (url: string) =>
        url ? (
          <a href={url} target="_blank" rel="noreferrer">
            打开
          </a>
        ) : (
          "—"
        ),
    },
    { title: "发送时间", dataIndex: "sent_at", width: 168, render: fmtDateTime },
    {
      title: "用户ID",
      dataIndex: "user_id",
      width: 120,
      render: (id: string) => <span className="admin-ledger-mono">{id.slice(0, 8)}…</span>,
    },
  ];

  return (
    <AdminListShell
      title="邮件派发记录"
      description="监管预警邮件成功写入库的发送记录（元数据，只读）。"
      err={err}
      errorBanner
      toolbar={
        <div className="admin-ledger-toolbar">
          <Input
            placeholder="用户 UUID 过滤"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            variant="borderless"
            style={{ width: 260 }}
            allowClear
          />
        </div>
      }
      table={(bodyY) => (
        <div className="admin-ledger-table-wrap admin-ledger-table-wrap--flex">
          <Spin spinning={loading}>
            <Table<AdminAlertDispatchRow>
              rowKey="id"
              className="admin-ledger-table"
              columns={columns}
              dataSource={items}
              pagination={{
                current: page,
                pageSize,
                total,
                showSizeChanger: true,
                pageSizeOptions: [10, 20, 50],
                showTotal: (t) => `共 ${t} 条`,
                onChange: (p, ps) => {
                  setPage(p);
                  setPageSize(ps);
                },
              }}
              scroll={{ x: 1000, y: bodyY }}
              locale={{ emptyText: "暂无记录" }}
            />
          </Spin>
        </div>
      )}
    />
  );
}
